import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const STATUS_ORDER = [
  "En attente",
  "Reçu au Québec",
  "En transit",
  "Arrivé à Abidjan",
  "En dédouanement",
  "En livraison",
  "Livré",
];

export const ALL_STATUSES = [...STATUS_ORDER, "Problème / Retenu en douane"];

export const STATUS_STYLES = {
  "En attente": { badge: "bg-slate-100 text-slate-700 border-slate-300", dot: "bg-slate-400" },
  "Reçu au Québec": { badge: "bg-sky-50 text-sky-700 border-sky-200", dot: "bg-sky-500" },
  "En transit": { badge: "bg-blue-50 text-blue-700 border-blue-300", dot: "bg-blue-600" },
  "Arrivé à Abidjan": { badge: "bg-indigo-50 text-indigo-700 border-indigo-200", dot: "bg-indigo-600" },
  "En dédouanement": { badge: "bg-amber-50 text-amber-700 border-amber-300", dot: "bg-amber-500" },
  "En livraison": { badge: "bg-cyan-50 text-cyan-700 border-cyan-300", dot: "bg-cyan-600" },
  "Livré": { badge: "bg-emerald-50 text-emerald-700 border-emerald-300", dot: "bg-emerald-600" },
  "Problème / Retenu en douane": { badge: "bg-rose-50 text-rose-700 border-rose-300", dot: "bg-rose-600" },
};

export function formatDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });
}

export function formatDateTime(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleString("fr-FR", {
    day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
}
